import { render, staticRenderFns } from "./AgentSetting.vue?vue&type=template&id=1bb1a23c&scoped=true&"
import script from "./AgentSetting.vue?vue&type=script&lang=ts&"
export * from "./AgentSetting.vue?vue&type=script&lang=ts&"
import style0 from "./AgentSetting.vue?vue&type=style&index=0&id=1bb1a23c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb1a23c",
  null
  
)

export default component.exports